import React from "react";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import PropTypes from "prop-types";
import "../../styles/components/tableHead.css";

/**
 * Komponente zur Darstellung des Headers einer Tabelle
 * @param id
 * @param headCells
 * @param onRequestSort
 * @param order
 * @param orderBy
 * @returns {JSX.Element}
 * @constructor
 */
function EATableHead({id, headCells, onRequestSort, order, orderBy}) {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    function createSortableHeader(headCell) {
        return (<TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : 'asc'}
            onClick={createSortHandler(headCell.id)}
        >
            {headCell.label}
            {orderBy === headCell.id ? (
                <span className="visuallyHidden">
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
            ) : null}
        </TableSortLabel>);
    }

    function createHeaderCell(headCell) {
        if (headCell.headerComponentProvider) {
            return headCell.headerComponentProvider();
        }
        if (headCell.componentProvider) {
            return headCell.label;
        }
        return createSortableHeader(headCell);
    }

    return (
        <TableHead id={id} className="tableHead">
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={headCell.style}
                    >
                        {createHeaderCell(headCell)}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EATableHead.propTypes = {
    headCells: PropTypes.arrayOf(PropTypes.object),
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired
};

export default EATableHead;
